import { Route, Navigate } from "react-router-dom";

import { CreateDataset } from "./CreateDataset";
import { CreateDatasetEvent } from "./CreateDatasetEvent";
import { Dataset } from "./Dataset";
import { loadDatasetByName, loadSortParamsFromUrl } from "./loaders";

export const DatasetsRoutes = () => [
  <Route key={"/"} index element={<Navigate to="/search" replace />} />,
  <Route key={"create"} path="create" element={<CreateDataset />} />,
  <Route
    key={"name"}
    path="name/:datasetName"
    loader={loadDatasetByName}
    shouldRevalidate={({ currentUrl, nextUrl }) => {
      return currentUrl.pathname !== nextUrl.pathname;
    }}
    // If the loader does not redirect to a dataset,
    // take the user to the dataset search page.
    element={<Navigate to="/search" replace />}
  />,
  <Route
    key={"id/events/create"}
    path=":datasetPath/events/create"
    element={<CreateDatasetEvent />}
  />,
  <Route
    id="datasetBrowser"
    key={"id/*"}
    path=":datasetPath/*"
    element={<Dataset />}
    loader={loadSortParamsFromUrl}
  />,
];
